import React from 'react';
import Media, { MediaProps } from '../Media';
import { LinkProps } from '@soluto-design/link';

import { Title, Text, Button } from '@soluto-design/react';

import CardBase from '../CardBase';
import cls from '@soluto-design/styles/cls';

export interface CardNavigationMediaProps {
    cta?: LinkProps;
    media?: MediaProps['media'];
    title?: string;
    text?: string;
}

export default function CardNavigationMedia({
    cta,
    media,
    title,
    text,
}: CardNavigationMediaProps) {
    return (
        <>
            <CardBase
                href={cta?.href}
                className={cls(
                    'group overflow-hidden rounded-large bg-background-brand-primary flex flex-col',
                    cta?.disabled && 'bg-background-disabled',
                )}>
                {title && (
                    <div
                        className={cls(
                            'flex flex-col gap-xs px-lg pt-lg pb-sm text-h400 text-text-static',
                            !cta?.disabled &&
                                !!media &&
                                ' md:pb-lg md:group-hover:pb-sm md:group-focus-visible:pb-sm md:transition-all md:ease-in-out md:duration-300',
                            cta?.disabled && 'text-text-disabled',
                        )}>
                        <Title component="h4" className="md:min-h-[2lh]">
                            {title}
                        </Title>
                    </div>
                )}

                <div
                    className={cls(
                        'px-lg',
                        media &&
                            'relative h-full pb-[calc(var(--soluto-spacing-lg)+258px)]',
                        !media && 'pb-lg',
                        !cta?.disabled &&
                            !!media &&
                            'md:pb-sm md:group-hover:pb-lg md:group-focus-visible:pb-lg md:transition-all md:ease-in-out md:duration-300',
                    )}>
                    <div className="md:min-h-[298px]">
                        {text && (
                            <Text
                                isHtml
                                component="div"
                                className={cls(
                                    'text-b400 text-text-secondary pt-sm md:pt-0',
                                    cta?.disabled && 'text-text-disabled',
                                )}>
                                {text}
                            </Text>
                        )}
                        {cta && (
                            <Button
                                variant="tertiary"
                                className="mt-xg"
                                size="medium"
                                rightIcon="arrow-direction--type-right"
                                href={cta.href}
                                tabIndex={-1}>
                                {cta.label}
                            </Button>
                        )}
                    </div>

                    {media && (
                        <div
                            className={cls(
                                'absolute bottom-0 left-0 w-full h-[258px] md:h-full z-10',
                                !cta?.disabled &&
                                    !!media &&
                                    'md:group-hover:translate-y-full md:group-focus-visible:translate-y-full md:transition-transform md:ease-in-out md:duration-300 bg-background-secondary',
                            )}>
                            <Media media={media} layout="fill" />
                        </div>
                    )}
                </div>
            </CardBase>
        </>
    );
}
